/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModuleContext } from '../../models/module-context';
import { PersonsAuthorizationCriteriaExplainResult } from '../../models/persons-authorization-criteria-explain-result';

export interface GetExplainUserAccess$Json$Params {
  companyId: string;
  userId: string;
  personId?: string;
  personEmail?: string;
  includeDeleted?: boolean;
  includeThirdPartyUser?: boolean;
  module?: ModuleContext;
}

export function getExplainUserAccess$Json(http: HttpClient, rootUrl: string, params: GetExplainUserAccess$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonsAuthorizationCriteriaExplainResult>> {
  const rb = new RequestBuilder(rootUrl, getExplainUserAccess$Json.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.path('userId', params.userId, {});
    rb.query('personId', params.personId, {});
    rb.query('personEmail', params.personEmail, {});
    rb.query('includeDeleted', params.includeDeleted, {});
    rb.query('includeThirdPartyUser', params.includeThirdPartyUser, {});
    rb.query('module', params.module, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonsAuthorizationCriteriaExplainResult>;
    })
  );
}

getExplainUserAccess$Json.PATH = '/company/{companyId}/explainAccess/{userId}';
